export function handleAjaxError(error) {
    var response = error.response;
    console.log(response);
    alert(response ? response.data.message : "Something went wrong. Please try again later.");
    console.error(error);
}
